
import React from "react";
import icons_dropdown from "../../base/assets/icons/icons_dropdown.svg";

interface IconComponentPropsDI{
  [key: string]: any
}

const  IconComponent:React.FC<IconComponentPropsDI> = (props)=> {
  return <img {...props}  src={icons_dropdown} alt="" />
}

export default IconComponent;